import React from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { businessCity, businessZipcode, businessKecamatan } from 'actions';
import {
  resetKybCityDropdown,
  resetKybKecamatanDropdown,
  resetKybZipcodeDropdown,
} from 'actions/kyb';
import {
  actSetAccountBusinessLocation,
  actUpdateAccountBusinessInfo,
} from 'actions/setting/account';
import styles from './style.css';

const validate = values => {
  const errors = {};
  if (!values.businessName || values.businessName.trim().length < 1) {
    errors.businessName = 'This field is required';
  }
  if (!values.address || values.address.trim().length < 1) {
    errors.address = 'This field is required';
  }
  if (!values.province) {
    errors.province = 'This field is required';
  }
  if (!values.city) {
    errors.city = 'This field is required';
  }
  if (!values.kecamatan) {
    errors.kecamatan = 'This field is required';
  }
  if (!values.zipcode) {
    errors.zipcode = 'This field is required';
  }
  return errors;
};

const inputField = field => (
  <div>
    <input
      {...field.input}
      type={field.type || 'text'}
      maxLength={field.maxLength}
      className={`form-control ${
        field.meta.touched && field.meta.error ? styles['input-error'] : ''
      }`}
      onKeyPress={e => (field.onKeyPress ? field.setOnlyNumber(e) : '')}
    />
    <small className={styles.error}>
      {field.meta.touched ? field.meta.error : ''}
    </small>
  </div>
);

const textareaField = field => {
  return (
    <div className={`${styles['textarea-field']}`}>
      <textarea
        {...field.input}
        maxLength={field.maxLength}
        className={`form-control ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

const renderSelectField = ({ input, meta: { touched, error }, children }) => (
  <div>
    <div>
      <select
        {...input}
        className={`form-control ${
          touched && error ? styles['input-error'] : ''
        }`}
      >
        {children}
      </select>
      <small className={styles.error}>{touched ? error : ''}</small>
    </div>
  </div>
);

class BusinessInfoForm extends React.Component {
  constructor(props) {
    super(props);
    if (props.businessKyb) {
      this.initializeForm();
    }
    this.state = {
      businessId: props.businessKyb.id,
    };
  }

  initializeForm() {
    const { businessKyb } = this.props;
    this.props.dispatch(
      actSetAccountBusinessLocation({
        province: businessKyb.province,
        city: businessKyb.city,
        kecamatan: businessKyb.kecamatan,
      })
    );
    const initData = {
      businessName: businessKyb.name,
      address: businessKyb.address,
      province: businessKyb.province,
      city: businessKyb.city,
      kecamatan: businessKyb.kecamatan,
      zipcode: businessKyb.postal_code,
    };
    this.props.initialize(initData);
  }

  handleProvinceChange = e => {
    const province = e.target.value;
    const provinceId = this.props.moka.businessProvinceState[province];
    this.props.dispatch(resetKybCityDropdown());
    this.props.dispatch(resetKybKecamatanDropdown());
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('BusinessInfoForm', 'city', null));
    this.props.dispatch(change('BusinessInfoForm', 'kecamatan', null));
    this.props.dispatch(change('BusinessInfoForm', 'zipcode', null));
    if (provinceId !== undefined && provinceId !== null) {
      this.props.dispatch(businessCity(provinceId));
    }
  };

  handleCityChange = e => {
    const city = e.target.value;
    const cityId = this.props.moka.businessCityState[city];
    this.props.dispatch(resetKybKecamatanDropdown());
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('BusinessInfoForm', 'kecamatan', null));
    this.props.dispatch(change('BusinessInfoForm', 'zipcode', null));
    if (cityId !== undefined && cityId !== null) {
      this.props.dispatch(businessKecamatan(cityId));
    }
  };

  handleKecamatanChange = e => {
    const kecamatan = e.target.value;
    const kecamatanId = this.props.moka.businessKecamatanState[kecamatan];
    this.props.dispatch(resetKybZipcodeDropdown());
    this.props.dispatch(change('BusinessInfoForm', 'zipcode', null));
    if (kecamatanId !== undefined && kecamatanId !== null) {
      this.props.dispatch(businessZipcode(kecamatanId));
    }
  };

  handleBusinessInfoSubmit = ({
    city,
    address,
    kecamatan,
    businessName,
    province,
    zipcode,
  }) => {
    const values = {
      city,
      kecamatan,
      province,
      postal_code: zipcode,
      name: businessName.trim(),
      address: address.trim(),
    };
    this.props.dispatch(
      actUpdateAccountBusinessInfo({
        values,
        businessId: this.state.businessId,
      })
    );
  };

  render() {
    const { handleSubmit, valid, onClickBack, moka } = this.props;
    const {
      businessProvinceState,
      businessCityState,
      businessZipcodeState,
      businessKecamatanState,
    } = moka;
    const provinceIdList = Object.keys(businessProvinceState);
    const cityIdList = Object.keys(businessCityState);
    const kecamatanIdList = Object.keys(businessKecamatanState);
    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>EDIT BUSINESS INFO</div>
        </div>
        <form
          className="col-xs-12"
          onSubmit={handleSubmit(this.handleBusinessInfoSubmit)}
        >
          <fieldset>
            <div className="form-group">
              <div className={styles['input-label']}>Business Name</div>
              <Field
                component={inputField}
                name="businessName"
                maxLength="30"
              />
            </div>
            <div className="form-group">
              <div className={styles['input-label']}>Business Address</div>
              <Field
                component={textareaField}
                name="address"
                placeholder="e.g. Malioboro Tower, Ruko Istana Kebon Jeruk, Jl. Milantro Raya No. 87 RT.1/RW.5"
                maxLength="100"
              />
            </div>
            <div className="form-group">
              <div className={styles['input-label']}>Province</div>
              <Field
                component={renderSelectField}
                onChange={this.handleProvinceChange}
                name="province"
              >
                <option key={0} value="">
                  Province
                </option>
                {provinceIdList.map((name, index) => (
                  <option value={name} key={index}>
                    {name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-group">
              <div className={styles['input-label']}>City / Kabupaten</div>
              <Field
                component={renderSelectField}
                onChange={this.handleCityChange}
                name="city"
              >
                <option key={0} value="">
                  City / Kabupaten
                </option>
                {cityIdList.map((name, index) => (
                  <option value={name} key={index}>
                    {name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-group">
              <div className={styles['input-label']}>Kecamatan</div>
              <Field
                component={renderSelectField}
                onChange={this.handleKecamatanChange}
                name="kecamatan"
              >
                <option key={0} value="">
                  Kecamatan
                </option>
                {kecamatanIdList.map((name, index) => (
                  <option value={name} key={index}>
                    {name}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-group">
              <div className={styles['input-label']}>Postal code</div>
              <Field component={renderSelectField} name="zipcode">
                <option key={0} value="">
                  Postal code
                </option>
                {businessZipcodeState.map(option => (
                  <option value={option.code} key={option.id}>
                    {option.code}
                  </option>
                ))}
              </Field>
            </div>
            <div className={`row ${styles['pb-50']}`}>
              <div className="col-12 col-xs-6">
                <button
                  type="button"
                  className={`btn btn-default ${styles['width-100']} ${
                    styles['back-button']
                  }`}
                  onClick={onClickBack}
                >
                  Back
                </button>
              </div>
              <div className="col-12 col-xs-6">
                <button
                  type="submit"
                  disabled={!valid}
                  className={`btn btn-primary ${styles['width-100']}`}
                >
                  Save
                </button>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

const mapForm = {
  form: 'businessInfoForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate, // a unique identifier for this form
};

export default reduxForm(mapForm)(BusinessInfoForm);
